import { useEffect } from "react";
import { PATH_DASHBOARD } from "../../routes/paths";
import { ICONS } from "./utils";

export default function DashBoardFunction() {
  const DashMenus = [
    {
      items: [
        { title: "Dashboard", path: PATH_DASHBOARD.app, icon: ICONS.dashboard },
        // {
        //   title: "Syllabus",
        //   path: PATH_DASHBOARD.syllabus,
        //   icon: ICONS.calendar,
        // },
        {
          title: "Courses",
          path: PATH_DASHBOARD.courses,
          icon: ICONS.calendar,
        },
        {
          title: "My Learning",
          path: PATH_DASHBOARD.mylearning,
          icon: ICONS.mylearning,
        },
        {
          title: "Live Class",
          path: PATH_DASHBOARD.event,
          icon: ICONS.ecommerce,
        },
        {
          title: "Study",
          path: PATH_DASHBOARD.freestudymaterial,
          icon: ICONS.studyfree,
        },
        // { title: "Revision", path: PATH_DASHBOARD.revision, icon: ICONS.revision },
        { title: "Doubts", path: PATH_DASHBOARD.doubts, icon: ICONS.doubt },
        // { title: "Shorts", path: PATH_DASHBOARD.shorts, icon: ICONS.ecommerce },
        { title: "Test", path: PATH_DASHBOARD.tests, icon: ICONS.test },
        // {
        //   title: "Quiz",
        //   path: PATH_DASHBOARD.quiz,
        //   icon: ICONS.calendar,
        // },
        // {
        //   title: "My Bookmarks",
        //   path: PATH_DASHBOARD.myBookmarks,
        //   icon: ICONS.ecommerce_1,
        // },
        // {
        //   title: "Mentorship", path: PATH_DASHBOARD.mentorship, icon: ICONS.mentorship
        // },
        // {
        //   title: "Assignment",
        //   path: PATH_DASHBOARD.assignment,
        //   icon: ICONS.assignments,
        // },
        {
          title: "Order",
          path: PATH_DASHBOARD.orderDetail,
          icon: ICONS.orders,
        },
        // {
        //   title: "Scholarship Test", path: PATH_DASHBOARD.scholarshipTest, icon: ICONS.menuItem
        // },
      ],
    },
  ];
  return DashMenus;
}
